export class MeasurementVO {
    /**
     * Defines a set of measurements:
     * @param measurements Number of measurements that will be taken.
     * @param intervalBetweenMeasurements Time interval between each measurement (in seconds).
     * @param waitFor Time interval to wait before taking new measurements (in seconds).
     * @param runUntil Time interval to run this measurement settings (in secods).
     */
    constructor(
        public readonly measurements: number,
        public readonly intervalBetweenMeasurements: number,
        public readonly waitFor: number,
        public readonly runUntil: number
    ) {
    }
}
